import { ObjectSchema, object, string } from "yup";

// ------------- PEMIT REQUEST -------------
export type PermitRequest = {
  mode: string;
  // time: string;
  datePermit: string;
  dateBack: string;
  pickup: string;
  pickupStatus: string;
  notes: string;
};

export const permitRequestSchema: ObjectSchema<PermitRequest> = object({
  mode: string().required(),
  // time: string().required(),
  datePermit: string().required("harus diisi"),
  dateBack: string().required(),
  pickup: string().required("harus diisi"),
  pickupStatus: string().required("harus diisi"),
  notes: string().required("harus diisi"),
});
// ------------- PEMIT REQUEST -------------
